export const SELLER_SUBSCRIPTION = 'seller_subscription'
export const BUYER_GENERAL = 'buyer_general'
